document.addEventListener('DOMContentLoaded', function () {
  // Obtener el valor del JSON desde el script generado en el Liquid
  const jsonElement = document.getElementById('product_linking_json');
  if (!jsonElement) return;

  let data;
  try {
    data = JSON.parse(jsonElement.textContent);
  } catch (e) {
    console.error('Error parsing product linking JSON', e);
    return;
  }

  // Validar que exista el search_query (ej. "Judy")
  if (!data.search_query) return;

  // Llamar al endpoint que devuelve los hermanos
  fetch(`/search?q=${encodeURIComponent(data.search_query)}&type=product&view=product-linking`)
    .then(response => response.text())
    .then(responseText => {
      let products;
      try {
        products = JSON.parse(responseText);
      } catch (e) {
        console.error('Error parsing product linking data:', e);
        return;
      }

      const container = document.querySelector('.product-linking-container');
      if (!container) return;

      // Limpiar contenido previo
      container.innerHTML = '';

      // Crear contenedor de swatches
      const swatchWrapper = document.createElement('div');
      swatchWrapper.classList.add('product-linking-swatches'); // usa la clase del CSS para diseño horizontal

      products.forEach(product => {
        const link = document.createElement('a');
        link.href = product.product_url;
        link.title = product.title;
        link.classList.add('product-linking-swatch');

        // Prioridad: Imagen > Color HEX > Gris fallback
        if (
          product.swatch_image &&
          !product.swatch_image.includes('Liquid error') && // ignora errores de Liquid
          product.swatch_image !== ''
        ) {
          const img = document.createElement('img');
          img.src = product.swatch_image;
          img.alt = product.title;
          img.classList.add('swatch-image');
          link.appendChild(img);
        } else if (product.swatch_color && product.swatch_color !== '') {
          const colorDiv = document.createElement('div');
          colorDiv.classList.add('swatch-color');
          colorDiv.style.backgroundColor = product.swatch_color; // usa HEX del metafield
          link.appendChild(colorDiv);
        } else {
          // fallback: si no hay ni imagen ni color, usa gris
          const fallbackDiv = document.createElement('div');
          fallbackDiv.classList.add('swatch-color');
          fallbackDiv.style.backgroundColor = '#ccc';
          link.appendChild(fallbackDiv);
        }

        swatchWrapper.appendChild(link);
      });

      // Insertar en el contenedor y mostrar
      container.appendChild(swatchWrapper);
      container.classList.remove('hidden');
    })
    .catch(err => console.error('Error fetching product linking data:', err));
});
